import React from "react";
import { DevIcons } from "./DevDashboardIcons";

const renderPerformanceIcon = (iconType, iconColor) => {
  switch (iconType) {
    case "trophy":
      return <DevIcons.Trophy size={22} color={iconColor} />;
    case "chart":
      return <DevIcons.BarChart size={22} color={iconColor} />;
    case "dollar":
      return <DevIcons.Dollar size={22} color={iconColor} />;
    case "users":
      return <DevIcons.Users size={22} color={iconColor} />;
    default:
      return <DevIcons.Trophy size={22} color={iconColor} />;
  }
};

const DevPerformanceSection = ({ items = [] }) => {
  return (
    <div className="dev-performance-container">
      <div className="dev-performance-header">
        <h3 className="dev-performance-title">
          Developer Performance{" "}
          <span className="dev-performance-sub">(Last 30 Days)</span>
        </h3>
      </div>

      <div className="dev-performance-grid">
        {items.map((item) => (
          <div key={item.id} className="dev-perf-card">
            <div
              className="dev-perf-icon-box"
              style={{ backgroundColor: item.iconBg }}
            >
              {renderPerformanceIcon(item.iconType, item.iconColor)}
            </div>

            <div className="dev-perf-info">
              <span className="dev-perf-label">{item.label}</span>
              <span className="dev-perf-machine-name">{item.title}</span>
              <span className="dev-perf-metrics">{item.metrics}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DevPerformanceSection;
